import { ReactNode, useRef } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useReveal } from './useReveal';

// Shell for the public marketing pages: paper ground, rail navigation, colophon footer and
// the shared entrance grammar. Styles live in src/styles/scene.css.
export default function SceneLayout({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useReveal(ref);
  return (
    <div ref={ref} className="scene">
      <Navbar variant="scene" />
      <main className="flex-1">{children}</main>
      <Footer variant="scene" />
    </div>
  );
}
